// routes
import { PATH_NSM, PATH_SETDEALER } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    noneligibleRecords: icon('ic_noneligible'),
    enablereupload: icon('ic_reupload'),
    dealerrequest: icon('ic_request'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    reprocess: icon('ic_reprocess'),
    raiseticket: icon('ic_raiseticket'),
};

const navConfig = [
    {
        items: [
            {
                title: 'Set Management', path: PATH_SETDEALER.dealer.maindealerpage, icon: ICONS.master,
                children: [
                    { title: 'Sets', path: PATH_SETDEALER.dealer.maindealerpage },

                ],
            },

        ],
    }
];
export default navConfig;